import React, { useState, useEffect } from 'react';
import { collection, getDocs, doc, updateDoc, getDoc, arrayUnion } from 'firebase/firestore';
import moment from 'moment';
import { db } from '../lib/firebase';
import { Link } from 'react-router-dom';
import './userTransaction.css';
import Loader from '../loader/Loader';
import cryptoGirl from '../assets/cryptoGirl.png';
import CryptoMarquee from '../Chart/CryptoMarquee';


const AddTransaction = () => {
    const [users, setUsers] = useState([]);
    const [selectedUserId, setSelectedUserId] = useState('');
    const [amount, setAmount] = useState(0);
    const [description, setDescription] = useState('');
    const [beneficiary, setBeneficiary] = useState('');
    const [date, setDate] = useState(moment().format('YYYY-MM-DD'));
    const [type, setType] = useState('credit');
    const [account, setAccount] = useState('Savings');
    const [userBalance, setUserBalance] = useState(0);
    const [accountBalance, setAccountBalance] = useState(0);
    const [loading, setLoading] = useState(true);
    const [successMessage, setSuccessMessage] = useState('');
    const [errorMessage, setErrorMessage] = useState('');
    const [isSubmitting, setIsSubmitting] = useState(false); // New state variable

    useEffect(() => {
        const fetchUsers = async () => {
            try {
                const querySnapshot = await getDocs(collection(db, 'users'));
                const usersList = querySnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
                setUsers(usersList);
                setLoading(false);
            } catch (error) {
                console.error('Error fetching users: ', error);
                setErrorMessage('Error fetching users.');
                setLoading(false);
            }
        };

        fetchUsers();
    }, []);

    const handleUserChange = async (e) => {
        const userId = e.target.value;
        setSelectedUserId(userId);
        try {
            const userDoc = await getDoc(doc(db, 'users', userId));
            if (userDoc.exists()) {
                const fetchedTransactions = userDoc.data().transactions || [];
                const calculatedBalance = fetchedTransactions.reduce((total, transaction) => {
                    return transaction.type === 'credit' ? total + transaction.amount : total - transaction.amount;
                }, 0);
                setUserBalance(calculatedBalance);

                const accountTransactions = fetchedTransactions.filter(txn => txn.account === account);
                const calculatedAccountBalance = accountTransactions.reduce((total, transaction) => {
                    return transaction.type === 'credit' ? total + transaction.amount : total - transaction.amount;
                }, 0);
                setAccountBalance(calculatedAccountBalance);
            }
        } catch (error) {
            console.error('Error fetching user balance: ', error);
            setErrorMessage('Error fetching user balance.');
        }
    };

    const handleAccountChange = (e) => {
        setAccount(e.target.value);
        if (selectedUserId) {
            handleUserChange({ target: { value: selectedUserId } });
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!selectedUserId || !amount || !description || !date || !type || !account || !beneficiary) {
            setErrorMessage('All fields are required.');
            return;
        }
        if (type === 'debit' && userBalance <= 0) {
            setErrorMessage('Cannot perform debit transaction. Balance is zero or negative.');
            return;
        }

        setIsSubmitting(true); // Disable button upon form submission

        try {
            const transaction = {
                amount: parseFloat(amount),
                description,
                date: moment(date).format('MMMM D, YYYY'),
                type,
                beneficiary,
                account,
            };

            await updateDoc(doc(db, 'users', selectedUserId), {
                transactions: arrayUnion(transaction),
            });

            setSuccessMessage(`Transaction added successfully! Click here to view the transaction.`);
            setTimeout(() => {
                setSuccessMessage('');
            }, 5000);

            const newBalance = type === 'credit' ? userBalance + transaction.amount : userBalance - transaction.amount;
            setUserBalance(newBalance);

            const newAccountBalance = type === 'credit' ? accountBalance + transaction.amount : accountBalance - transaction.amount;
            setAccountBalance(newAccountBalance);

            setAmount(0);
            setDescription('');
            setBeneficiary('');
            setDate(moment().format('YYYY-MM-DD'));
            setType('credit');
        } catch (error) {
            console.error('Error adding transaction: ', error);
            setErrorMessage('Error adding transaction.');
        } finally {
            setIsSubmitting(false); // Re-enable the button after transaction is processed
        }
    };

    if (loading) {
        return <Loader />;
    }

    if (errorMessage) {
        return <div>{errorMessage}</div>;
    }

    return (
        <div className='pageCover'>
                  <CryptoMarquee />

            <div className="transactions">
                <div className='img'> <img src={cryptoGirl} alt="" className='myImg' /></div>
                <h2>Add Transaction</h2>
                <form onSubmit={handleSubmit}>
                    <div className="container">
                        <div className="row">
                            <div className="col-md-4">
                                <label>User:</label>
                                <select value={selectedUserId} onChange={handleUserChange} required>
                                    <option value="">Select a user</option>
                                    {users.map(user => (
                                        <option key={user.id} value={user.id}>{user.fullName}</option>
                                    ))}
                                </select>
                            </div>
                            <div className="col-md-4">
                                <label>Type:</label>
                                <select
                                    value={type}
                                    onChange={(e) => setType(e.target.value)}
                                    required
                                >
                                    <option value="credit">Credit</option>
                                    <option value="debit">Debit</option>
                                </select>
                            </div>
                            <div className="col-md-4">
                                <label>Account:</label>
                                <select
                                    value={account}
                                    onChange={handleAccountChange}
                                    required
                                >
                                    <option value="Bitcoin">Bitcoin</option>
                                    <option value="Ethereum">Ethereum</option>
                                    <option value="USDT">USDT</option>
                                    <option value="Solana">Solana</option>
                                    <option value="Doge">Doge</option>
                                    <option value="Arbitrium">Arbitrium</option>
                                </select>
                            </div>
                        </div>
                    </div>
                    <div className="container">
                        <div className="row">
                            <div className="col-md-6">
                                <label>Amount:</label>
                                <input
                                    type="number"
                                    value={amount}
                                    onChange={(e) => setAmount(e.target.value)}
                                    required
                                    min="0.01"
                                    step="0.01"
                                />
                            </div>
                            <div className="col-md-6">
                                <label>Date (MM/DD/YYYY):</label>
                                <input
                                    type="date"
                                    value={date}
                                    onChange={(e) => setDate(e.target.value)}
                                    required
                                />
                            </div>
                        </div>
                    </div>
                    <div className="container">
                        <div className="row">
                            <div className="col-md-6">
                                <label>Description:</label>
                                <input
                                    type="text"
                                    value={description}
                                    placeholder='This is for shopping'
                                    onChange={(e) => setDescription(e.target.value)}
                                    required
                                />
                            </div>
                            <div className="col-md-6">
                                <label>Beneficiary Text:</label>
                                <input
                                    type="text"
                                    value={beneficiary}
                                    placeholder='A wallet address maybe'
                                    onChange={(e) => setBeneficiary(e.target.value)}
                                    required
                                />
                            </div>
                        </div>
                    </div>
                    {successMessage && <p className="success-msg">
                        <Link className="Link" to={`/user/${selectedUserId}/transactions`}>{successMessage}</Link>
                    </p>}
                    {errorMessage && <p className="error-message">{errorMessage}</p>}
                    <button type="submit" disabled={isSubmitting || (type === 'debit' && userBalance <= 0)}>
                        {isSubmitting ? 'Submitting...' : 'Add Transaction'}
                    </button>
                </form>
            </div>
        </div>
    );
};

export default AddTransaction;
